import { TableContainer } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import styled from "styled-components";

const StyledTable = styled(Table)`
  &.MuiTable-root {
    width: 100%;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-spacing: 0 0;
    border-collapse: separate;
    background: inherit;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-radius: 1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
`;
const StyledTableHead = styled(TableHead)`
  &.MuiTableHead-root {
    background-color: #f1f5f9;
    padding: 1.25rem 2rem;
  }

  /* Style for sticky header */
  .MuiTableCell-stickyHeader {
    background-color: #f1f5f9 !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 100 !important;
  }
`;
const StyledTableRow = styled(TableRow)`
  &.MuiTableRow-root {
    background-color: white;
    width: 100%;
    flex: 1;
  }

  ${StyledTableHead} &.MuiTableRow-root {
    background-color: inherit;
  }

  &.MuiTableRow-root .MuiTableRow-hover:hover,
  &.MuiTableRow-root .Mui-selected {
    background-color: rgb(237 244 255);
  }
  &.MuiTableRow-root[data-clickable="true"] {
    cursor: pointer;
    &:hover {
      background-color: rgb(237 244 255);
    }
  }
`;

const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px;
    line-height: 18px;
    color: #0a0a29;
    font-weight: 800;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    line-height: 24px;
    padding: 1.25rem 0 1.25rem 16px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }
`;

const StyledTableBoreredCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px;
    line-height: 18px;
    color: #0a0a29;
    font-weight: 800;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    line-height: 24px;
    padding: 0.4rem 0 0.4rem 16px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
    &:not(:last-child) {
      border-right: 1px solid rgba(224, 224, 224, 1);
    }
  }
`;

const StyledRosterCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 14px;
    line-height: 22px;
    color: #3a3a4d;
    font-weight: 900;
    text-transform: capitalize;
    background: #fff;
    border-bottom: 2px solid rgba(0, 0, 0, 0.06);
    letter-spacing: 0.02em;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  &.MuiTableCell-root {
    line-height: 28px;
    padding: 0.7rem 0 0.7rem 18px;
    background: #fff;
    border-bottom: 2px solid rgba(0, 0, 0, 0.06);
    font-size: 14px;
    font-weight: 800;
    color: #222b45;
    &:first-child {
      padding-left: 1.5rem;
      border-left: none;
      border-top-left-radius: 0;
    }
    &:last-child {
      border-top-right-radius: 0;
      border-right: none;
    }
  }
`;

const CleanCell = styled(TableCell)`
  &.MuiTableCell-root {
    border: none;
    padding: 0;
  }
`;

const StyledCellSm = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px !important;
    line-height: 12px;
    color: #0a0a29;
    font-weight: 700;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    font-size: 12px !important;
    line-height: 12px;
    padding: 0.7rem 0 0.7rem 18px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }
`;

const StyledTableContainer = styled(TableContainer)`
  &.MuiTableContainer-root {
    overflow: hidden;
    border-radius: 1rem;
  }
`;

export {
  StyledTable,
  StyledTableHead,
  StyledTableRow,
  StyledTableCell,
  CleanCell,
  StyledCellSm,
  StyledRosterCell,
  StyledTableBoreredCell,
  StyledTableContainer,
};
